<span class="backButton-container" (click)="goBack()" *ngIf="checkButtonActive()">
  <i class="codere-icon icon-arrow-double"></i>
</span>
